// extracted by mini-css-extract-plugin
export default {"text":"WarningModal_text__svKcA"};